import React, {useState, useContext, useRef, useEffect} from "react";
import styled from "styled-components";
import ModuleSettings from "../utils/moduleSettings";

export default React.memo(function CellCard ( {name, batchName, ELname, image, viewMore}  ) { 
    const listRef = useRef();
    const settings = useContext(ModuleSettings);
    const [isHovered, setIsHovered] = useState(false);
    const [positionTop, setPositionTop] = useState(0);
    
    const handleButton = () => {
        // set module variables: cellName && display cell info
        console.log(positionTop);
        settings.upDateSettings({'value1':true, 'value2':name, 'value3':positionTop});
    }

    const handleScroll = () => {
        const y = listRef.current.getBoundingClientRect().top;
        setPositionTop(y);        
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, true);
        return () => {
          window.removeEventListener("scroll", handleScroll, true);
        };
      }, []);

return (
    <Container
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    >        
        <div className="info-container" ref={listRef}>
            <img
                src={`data:image/jpeg;base64,${image}`} 
                alt="card"
            />     
            <h5> {name} </h5>
            {/* <h6> EL module: {ELname} </h6>
            <h6> Batch: {batchName} </h6> */}

            {viewMore && isHovered && (
            <div className="hover" onClick={handleButton}>
                <div className="info-container">
                <img
                    src={`data:image/jpeg;base64,${image}`} 
                    alt="card"
                />     
                <h4> {name} </h4>
                <button> View more </button>
                </div>            
            </div>)}

        </div>
        
    </Container>
);
});

const Container = styled.div`
max-width: 180px;
width: 180px;
height: 100%;
cursor: pointer;
position: relative;
padding: 1rem;
border-radius: 5px;
.info-container {
    gap: 2rem;
    color: black;
    img {
        width: 100%;
        height: 100%;
        z-index: 10;
    }
}
.hover {
    z-index: 99;
    height: max-content;
    width: 180px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
    transition: 0.3s ease-in-out;    
    background: white;
    .info-container {  
        text-align: center; 
        padding: 1rem;
        gap: 2rem;
        img {
            width: 100%;
            height: 100%;
            z-index: 10;
        }
        button {
            padding: 0.5rem 1rem;
            background-color: #E55B41;
            border: none;
            cursor: pointer;
            color: white;
            border-radius: 0.2rem;
            font-weight: bolder;
            font-size: 1.05rem;            
        }
    }
}
`;

